var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.getComponents,{tag:"component",attrs:{"data":_vm.formData,"config":_vm.baseData,"disable":_vm.disableValue(_vm.baseData)},on:{"fileValid":_vm.fileValid,"update:data":function($event){_vm.formData=$event}}}),(_vm.baseData.rules.otherConfig.isTip == true)?_c('p',[_c('span',{staticClass:"tipStyle",style:({
        color: _vm.baseData.rules.otherConfig.tipColor || '#606266',
      })},[_vm._v("提示："+_vm._s(_vm.baseData.rules.otherConfig.tipValue))])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }